import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";

export const Page4 = () => {
  return (
    <ReusablePDFLayout>
    <div className="parentcls">
        <p className="bolds" style={{ margin: "15px 0" }}>
          Responsibilities:
        </p>
        <p className="para">
          In the <span > day-to-day </span> functioning or carrying out all responsibilities,
          you will receive instructions from your reporting authority or a
          person acting on behalf of the reporting authority and will undertake
          to abide by any suggestions given by any such assigned person(s). You
          shall comply with all the standards/specific Policies and procedures
          laid down by the Company from time to time.
        </p>
        <p className="bolds" style={{ margin: "15px 0" }}>
          Travel:
        </p>
        <p className="para">
          As per the requirements of your position, you could be expected to
          travel on business needs and may however be required to work at any
          place of business which the Company has or may later acquire.
        </p>
        <p className="bolds" style={{ margin: "15px 0" }}>
          Transfer:
        </p>
        <p className="para">
          Though you have been engaged for a specific position, the company
          reserves the right to transfer you to any other location, department,
          establishment, factory or branch of the company/Group in existence now
          or which may be established hereafter in India or aboard. In such
          cases, you will be governed by the terms and conditions of service
          applicable to the new assignment, without any additional remuneration.
        </p>
        {/* <p className="para">Non-Compete:</p> */}
        <p className="bolds" style={{ margin: "15px 0" }}>
          During Employment:
        </p>
        <p className="para">
          {/* You shall not, during your employment with the Company, without the
          prior written consent of the Company, carry on, or be engaged in, or
          be concerned with, or interested in, or employed by, any person
          engaged in or concerned with or interested in a business which is the
          same as, or substantially similar to, or in competition with, the
          Company's business. */}
          During your employment with the Company, you shall not, without the Company’s 
          prior written consent, work for, assist, or be involved—directly or indirectly—with 
          any individual or organization that is engaged in the same, 
          similar, or competing business as that of the Company. 
        </p>
        <p className="bolds" style={{ margin: "15px 0" }}>
          Post-Employment:
        </p>
        <p className="para">
          {/* For a one (1) year period following the conclusion of your employment,
          you shall not in any capacity, directly or indirectly advise, manage,
          render or perform services to or for any person or entity which is
          engaged in a business competitive to that of the Company within any
          geographical location wherein the Company sells or markets its
          services at the time of such conclusion. */}
          For a period of one (1) year after the termination of your employment, you shall not, 
          directly or indirectly, engage with, advise, or provide services to
           any person or organization that competes with the Company’s business in 
           any location where the Company operates or markets its 
          services at the time of your separation. 
        </p>
      </div>
    </ReusablePDFLayout>
  );
};
